import cx from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import "./ServiceUnavailablePlaceholder.css";

var ServiceUnavailablePlaceholder = function ServiceUnavailablePlaceholder(_a) {
  var className = _a.className,
      title = _a.title,
      text = _a.text,
      secondaryText = _a.secondaryText,
      blockName = _a.blockName;
  return React.createElement("div", {
    className: cx(blockName, className)
  }, React.createElement("h1", {
    className: blockName + "__title"
  }, title), React.createElement("div", {
    className: cx(blockName + "__icon", 'icon-custom-alert-circle')
  }), React.createElement("p", {
    className: blockName + "__text"
  }, text), React.createElement("p", {
    className: blockName + "__secondary-text"
  }, secondaryText));
}; //@ts-ignore


ServiceUnavailablePlaceholder.propTypes = {
  blockName: PropTypes.string,
  className: PropTypes.string,
  title: PropTypes.string,
  text: PropTypes.string,
  secondaryText: PropTypes.string
};
ServiceUnavailablePlaceholder.defaultProps = {
  blockName: 'nx-service-unavailable-placeholder',
  title: 'Service Unavailable',
  text: "Sorry, we're having trouble retrieving this information.",
  secondaryText: 'Please contact your administrator.'
};
export default ServiceUnavailablePlaceholder;

try {
  // @ts-ignore
  ServiceUnavailablePlaceholder.__docgenInfo = {
    "description": "",
    "displayName": "ServiceUnavailablePlaceholder",
    "props": {
      "blockName": {
        "defaultValue": null,
        "description": "",
        "name": "blockName",
        "required": true,
        "type": {
          "name": "string"
        }
      },
      "className": {
        "defaultValue": null,
        "description": "",
        "name": "className",
        "required": false,
        "type": {
          "name": "string | undefined"
        }
      },
      "title": {
        "defaultValue": null,
        "description": "",
        "name": "title",
        "required": true,
        "type": {
          "name": "string"
        }
      },
      "text": {
        "defaultValue": null,
        "description": "",
        "name": "text",
        "required": true,
        "type": {
          "name": "string"
        }
      },
      "secondaryText": {
        "defaultValue": null,
        "description": "",
        "name": "secondaryText",
        "required": true,
        "type": {
          "name": "string"
        }
      }
    }
  };
} catch (__react_docgen_typescript_loader_error) {}